"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 32%;\n  height: calc(", " + ", ");\n  opacity: 0.75;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: calc(", " + ", ");\n  margin-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-bottom: 56.25%;\n  position: relative;\n  margin-bottom: ", ";\n  > ", " {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultGridPlaceholder = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

function DefaultGridPlaceholder() {
  return react_1.default.createElement("div", null, react_1.default.createElement(PlaceholderHero, null, react_1.default.createElement(PlaceholderBlock, null)), react_1.default.createElement(PlaceholderTitle, null), react_1.default.createElement(PlaceholderSubtitle, null));
}

exports.DefaultGridPlaceholder = DefaultGridPlaceholder;
var PlaceholderBlock = web_1.styled.div(_templateObject(), function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@border-radius-base'];
});
var PlaceholderHero = web_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@size-s'];
}, PlaceholderBlock);
var PlaceholderTitle = (0, web_1.styled)(PlaceholderBlock)(_templateObject3(), function (props) {
  return props.theme['@font-size-lg'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xs'];
});
var PlaceholderSubtitle = (0, web_1.styled)(PlaceholderBlock)(_templateObject4(), function (props) {
  return props.theme['@font-size-sm'];
}, function (props) {
  return props.theme['@size-xs'];
});